// extracted by mini-css-extract-plugin
module.exports = {"main":"NewInsight_main__3E1bK"};